import { useRouter } from "next/router";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import MainPortfolioHighlight from "./Highlight";
import MainPortfolioScore from "./Score";
import MainPortfolioSim from "./Sim";
import MainPortfolioRisk from "./Risk";
import PortfolioTotalAmount from "./TotalAmount";
import { TYPO } from "styles/Typo";
import { useMutation } from "@tanstack/react-query";
import { usePortfolioLastView } from "utils/clientAPIs/portfolio";
import Button from "components/common/buttons/buttons";
import DeleteModal from "components/modals/DeleteModal";
import { usePortfolioDelete } from "lib/analytics/react/hooks";
function MainPortfolioIndex({
  isMobile,
  portId,
}: {
  isMobile: boolean;
  portId: number | null;
}) {
  const router = useRouter();
  const { data: session } = useSession();
  const [isLoading, setIsLoading] = useState(false);
  const portfolioDelete = usePortfolioDelete();
  usePortfolioLastView();
  const { mutate } = useMutation({
    mutationFn: async () => {
      const res = await fetch(
        `/api/auth/user?session=${session?.user?.email}`,
        {
          method: "PUT",
          body: JSON.stringify({
            enteredInput: {
              method: "portfolioDelete",
              portfolio: {
                portName: "test",
                portID: portId,
              },
            },
          }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    },
  });
  const deletePortfolio = async () => {
    try {
      setIsLoading(true);
      await mutate();
      portfolioDelete.success();
      router.replace("/portfolio/new");
    } catch (err) {
      portfolioDelete.fail("backend_" + (err as any)?.status || "500");
    } finally {
      setIsLoading(false);
    }
  };
  const [isRecommandActive, setIsRecommandActive] = useState(false);
  const [isOpenPortfolioDeleteModal, setIsOpenPortfolioDeleteModal] =
    useState(false);
  useEffect(() => {
    if (!portId) return;
    const lastView = localStorage.getItem(`pf-${portId}-recommand-lastview`);
    const lastEdit = localStorage.getItem(`pf-${portId}-edit`);
    if (lastEdit) {
      // 마지막 뷰 시간이 마지막 수정 시간보다 오래된 경우
      if (!lastView || Number(lastView) < Number(lastEdit)) {
        setIsRecommandActive(true);
      }
    }
  }, [portId]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full bg-graybg"></div>
    );
  }
  return (
    <div className="bg-grayBackground flex flex-col relative ">
      <div
        className="sticky z-10 bg-grayBackground "
        style={{
          top: isMobile ? "56px" : "calc(56px + 64px)",
        }}
      >
        <MainPortfolioHighlight
          portId={portId}
          isRecommandActive={isRecommandActive}
        />
      </div>
      {isRecommandActive && (
        <div className="flex flex-col">
          <div className="px-[46px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="8"
              viewBox="0 0 20 8"
              fill="none"
            >
              <path d="M20 8L10 0L0 8H20Z" fill="#3182F6" fill-opacity="0.15" />
            </svg>
          </div>
          <div
            className="flex flex-col px-6 py-[14px]"
            style={{
              background: "rgba(49, 130, 246, 0.15)",
            }}
          >
            <p className={`${TYPO.TYPO8_RG} text-gray70`}>
              포트폴리오를 편집하셨나요?
            </p>
            <p className={`${TYPO.TYPO6_MD} text-blue60`}>
              새 처방전을 확인해보세요
            </p>
          </div>
        </div>
      )}
      <PortfolioTotalAmount portId={portId as number} />

      <MainPortfolioScore portId={portId} />
      <MainPortfolioSim portId={portId} />
      <MainPortfolioRisk portId={portId} />
      <div className="flex items-center justify-center p-4">
        <Button
          type="tertiary"
          size="md"
          clickHandler={() => {
            portfolioDelete.start({
              portfolio_id: portId as number,
              from_list_id: "portfolio_delete",
            });
            setIsOpenPortfolioDeleteModal(true);
          }}
          text="포트폴리오 삭제"
          disabled={isLoading}
          btnClass="!bg-grayOpacity10 !text-gray60"
          dataGtmId="pf-main-delete-button"
        />
      </div>
      {isOpenPortfolioDeleteModal && (
        <DeleteModal
          title={"포트폴리오를 삭제할게요"}
          subTitle={"하위 종목들이 함께 지워져요."}
          isOpenDeleteModal={isOpenPortfolioDeleteModal}
          setIsOpenDeleteModal={setIsOpenPortfolioDeleteModal}
          deleteHandler={deletePortfolio}
          portfolioDelete={portfolioDelete}
        />
      )}
    </div>
  );
}

export default MainPortfolioIndex;
